// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrticketspg-inline-1 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 12px;
}

.hrticketspg-inline-2 {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.hrticketspg-inline-3 {
  padding: 0;
  overflow-x: auto;
}

.hrticketspg-inline-4 {
  font-family: monospace;
  font-size: 11px;
}

.hrticketspg-inline-5 {
  font-weight: 600;
}

.hrticketspg-inline-6 {
  font-size: 11px;
}

.hrticketspg-inline-7 {
  max-width: 240px;
  font-size: 11px;
  color: #475569;
}

.hrticketspg-inline-8 {
  margin-top: 12px;
}

.hrticketspg-inline-9 {
  padding: 0;
}

.hrticketspg-inline-10 {
  padding: 10px 14px;
  border-bottom: 1px solid #f1f5f9;
}

.hrticketspg-inline-11 {
  font-size: 12px;
  font-weight: 600;
}

.hrticketspg-inline-12 {
  font-size: 10px;
  color: #94a3b8;
  margin-top: 2px;
}

.hrticketspg-inline-13 {
  margin-bottom: 12px;
}

.hrticketspg-inline-14 {
  font-size: 12px;
  background: #f8fafc;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.hrticketspg-inline-15 {
  font-size: 12px;
  background: #eff6ff;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.hrticketspg-dyn-1 {
  margin-left: auto;
  font-size: 12px;
  color: var(--hrticketspg-1-color);
}

.hrticketspg-dyn-2 {
  text-align: center;
  padding: 30px;
  color: var(--hrticketspg-2-color);
}

.hrticketspg-dyn-3 {
  text-align: center;
  padding: 30px;
  color: var(--hrticketspg-3-color);
}

.hrticketspg-dyn-4 {
  font-size: 11px;
  font-weight: 600;
  color: var(--hrticketspg-4-color);
}

.hrticketspg-dyn-5 {
  font-size: 11px;
  color: var(--hrticketspg-5-color);
}

.hrticketspg-dyn-6 {
  text-align: center;
  padding: 20px;
  color: var(--hrticketspg-6-color);
}

.hrticketspg-dyn-7 {
  font-size: 11px;
  color: var(--hrticketspg-7-color);
}

.hrticketspg-dyn-8 {
  font-size: 11px;
  color: var(--hrticketspg-8-color);
  margin-bottom: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrTicketsPg.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB","sourcesContent":[".hrticketspg-inline-1 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2563eb;\n  margin-bottom: 12px;\n}\n\n.hrticketspg-inline-2 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.hrticketspg-inline-3 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.hrticketspg-inline-4 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.hrticketspg-inline-5 {\n  font-weight: 600;\n}\n\n.hrticketspg-inline-6 {\n  font-size: 11px;\n}\n\n.hrticketspg-inline-7 {\n  max-width: 240px;\n  font-size: 11px;\n  color: #475569;\n}\n\n.hrticketspg-inline-8 {\n  margin-top: 12px;\n}\n\n.hrticketspg-inline-9 {\n  padding: 0;\n}\n\n.hrticketspg-inline-10 {\n  padding: 10px 14px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.hrticketspg-inline-11 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.hrticketspg-inline-12 {\n  font-size: 10px;\n  color: #94a3b8;\n  margin-top: 2px;\n}\n\n.hrticketspg-inline-13 {\n  margin-bottom: 12px;\n}\n\n.hrticketspg-inline-14 {\n  font-size: 12px;\n  background: #f8fafc;\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n\n.hrticketspg-inline-15 {\n  font-size: 12px;\n  background: #eff6ff;\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n\n.hrticketspg-dyn-1 {\n  margin-left: auto;\n  font-size: 12px;\n  color: var(--hrticketspg-1-color);\n}\n\n.hrticketspg-dyn-2 {\n  text-align: center;\n  padding: 30px;\n  color: var(--hrticketspg-2-color);\n}\n\n.hrticketspg-dyn-3 {\n  text-align: center;\n  padding: 30px;\n  color: var(--hrticketspg-3-color);\n}\n\n.hrticketspg-dyn-4 {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--hrticketspg-4-color);\n}\n\n.hrticketspg-dyn-5 {\n  font-size: 11px;\n  color: var(--hrticketspg-5-color);\n}\n\n.hrticketspg-dyn-6 {\n  text-align: center;\n  padding: 20px;\n  color: var(--hrticketspg-6-color);\n}\n\n.hrticketspg-dyn-7 {\n  font-size: 11px;\n  color: var(--hrticketspg-7-color);\n}\n\n.hrticketspg-dyn-8 {\n  font-size: 11px;\n  color: var(--hrticketspg-8-color);\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
